class PairsWith extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('.product-recommendations');
  }

  connectedCallback() {
    if (this.container.dataset.hasMetafields) {
      this.initRecommendedSlider();
    } else {
      const url = this.container.dataset.url;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.container.innerHTML = recommendations.innerHTML;

            this.initRecommendedSlider();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  initRecommendedSlider = () => {
    const slider = this.container.querySelector('.splide');

    new Splide(slider, {
      pagination: false,
      speed: 1000,
      perPage: 3,
      perMove: 3,
      gap: '0rem',
      breakpoints: {
        20000: {
          gap: '0rem',
          perPage: 4,
          perMove: 4,
        },
        1023: {
          gap: '3rem',
          perPage: 3,
          perMove: 3,
        },
        767: {
          gap: '2rem',
          perPage: 2,
          perMove: 2,
        },
      },
    }).mount();
  };
}

customElements.define('pairs-with', PairsWith);
